import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { camelCase, mapKeys, snakeCase } from 'lodash';
import { EnvService } from 'src/app/env.service';

@Injectable()
export class PropertiesCaseInterceptor implements HttpInterceptor {
  constructor(private env: EnvService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes(this.env.API_BASE_PATH)) {
      const modRequest = request.clone({ body: this.keysToSnake(request.body) });

      return next.handle(modRequest).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            let camelCaseObject = this.keysToCamel(event.body);
            const modEvent = event.clone({ body: camelCaseObject });
            return modEvent;
          }
        })
      );
    }

    return next.handle(request);
  }

  isArray = function (a) {
    return Array.isArray(a);
  };

  isObject = function (o) {
    return o === Object(o) && !this.isArray(o) && typeof o !== 'function';
  };

  toCamel = (s) => {
    return s != '__typename' && s.includes('_') ? camelCase(s) : s;
  };

  toSnake = (s) => {
    return s != '__typename' ? snakeCase(s) : '__typename';
  };

  keysToCamel = function (o) {
    if (this.isObject(o)) {
      const n = {};

      Object.keys(o).forEach((k) => {
        n[this.toCamel(k)] = this.keysToCamel(o[k]);
      });

      return n;
    } else if (this.isArray(o)) {
      return o.map((i) => {
        return this.keysToCamel(i);
      });
    }

    return o;
  };

  keysToSnake = function (o) {
    if (this.isObject(o)) {
      const n = {};

      Object.keys(o).forEach((k) => {
        n[this.toSnake(k)] = this.keysToSnake(o[k]);
      });

      return n;
    } else if (this.isArray(o)) {
      return o.map((i) => {
        return this.keysToSnake(i);
      });
    }

    return o;
  };
}
